import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import { Color } from '../Constants';

const styles = theme => ({
  appBar: {
    position: 'relative',
    background: Color.green
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: 'white'
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomFullDialog(props) {
  const classes = props.classes;
  //withStyles(styles);

    function handleClose() {
        props.handleClose();
    }

  return (
        <Dialog disableEscapeKeyDown={true} fullScreen open={props.open} onClose={handleClose} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
            <Toolbar>
                
                <Typography variant="h6" className={classes.title}>
                    {props.title}
                </Typography>
                <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                    <CloseIcon />
                </IconButton>
                {/* <Button color="inherit" onClick={handleClose}>
                    save
                </Button> */}
            </Toolbar>
            </AppBar>
            <div style={{background: '#f5f5f5'}}>
            {props.children}
            </div>
        </Dialog>
  );
};

CustomFullDialog.propTypes = {
    title: PropTypes.string,
    // buttonText: PropTypes.string.isRequired,
    handleClose: PropTypes.func,
    open: PropTypes.bool.isRequired
};

export default withStyles(styles)(CustomFullDialog);